import React, { useState } from "react";
import {
  Typography,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import AddIcon from "@mui/icons-material/Add";
import { Delete } from "@mui/icons-material";
import ReusableDialog from "../../../../common/dialog/dialog";

const ImportantPeople = ({ contacts, setContacts }) => {
  const [openContacts, setContactsOpen] = useState(false);
  const [newContacts, setNewContacts] = useState({
    importName: "",
    importArrange: "",
    contactNumber: "",
  });

  // Handler for input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewContacts((prevContacts) => ({
      ...prevContacts,
      [name]: value,
    }));
  };

  // Handler for phone input change
  const handlePhoneChange = (phone) => {
    setNewContacts((prevContacts) => ({
      ...prevContacts,
      contactNumber: phone,
    }));
  };

  // Handler for adding a new professional
  const handleAddContacts = () => {
    setContacts((prevContacts) => [...prevContacts, newContacts]); // Add new data to contacts array
    setNewContacts({
      importName: "",
      importArrange: "",
      contactNumber: "",
    });
    setContactsOpen(false); // Close the dialog after adding
  };

  // Check if all fields are filled
  const isAddButtonDisabled = !(newContacts.importName && newContacts.importArrange && newContacts.contactNumber);

  // Handler to delete a contact
  const handleDeleteContact = (index) => {
    setContacts((prevContacts) => prevContacts.filter((_, i) => i !== index));
  };

  return (
    <>
      <Typography sx={{ fontSize: "18px", color: "black" }} mt={5}>
        Important People In My Life
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={10}>
          <Typography sx={{ fontSize: "14px", color: "black" }} align='left' mb={2}>
            Specify whether contact is open, supervised or forbidden and enter special arrangements wherever required.
          </Typography>
          <Grid container spacing={2} ml={1} mt={1} mb={1}>
            <TableContainer component={Paper}>
              <Table aria-label='important people table'>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E3F2FD", fontSize: "12px", color: "#1751D0" }}>Name</TableCell>
                    <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E3F2FD", fontSize: "12px", color: "#1751D0" }}>Contact Details</TableCell>
                    <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E3F2FD", fontSize: "12px", color: "#1751D0" }}>Contact Arrangements</TableCell>
                    <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E3F2FD", textAlign: "right" }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {contacts.map((contact, index) => (
                    <TableRow key={index}>
                      <TableCell>{contact.importName}</TableCell>
                      <TableCell>{contact.contactNumber}</TableCell>
                      <TableCell>{contact.importArrange}</TableCell>
                      <TableCell align='right'>
                        <IconButton color='primary' aria-label='delete' onClick={() => handleDeleteContact(index)}>
                          <Delete />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          {/* Add More Button */}
          <Button color='primary' startIcon={<AddIcon />} onClick={() => setContactsOpen(true)}>
            Add More Contacts
          </Button>

          {/* Dialog for Adding New Professional */}
          <ReusableDialog
            isOpen={openContacts}
            onClose={() => setContactsOpen(false)}
            title='Add another professional person?'
            contentText='Add the relevant details to the fields to add another person to the involved parties.'
            onSubmit={handleAddContacts}
            submitText='Add'
            cancelText='Cancel'
            disable={isAddButtonDisabled}
          >
            <Box mt={2}>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={8}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Name
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder='Enter the Name'
                    name='importName'
                    value={newContacts.importName}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={8}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Contact No
                  </Typography>
                  <PhoneInput
                    country={"gb"}
                    value={newContacts.contactNumber}
                    onChange={handlePhoneChange}
                    containerStyle={{ width: "100%" }}
                    inputStyle={{ width: "100%", height: "55px", fontSize: "16px" }}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={10}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Contact Arrangements
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder='Enter Contact Arrangements'
                    name='importArrange'
                    value={newContacts.importArrange}
                    onChange={handleInputChange}
                    multiline
                    rows={3}
                  />
                </Grid>
              </Grid>
            </Box>
          </ReusableDialog>
        </Grid>
      </Grid>
    </>
  );
};

export default ImportantPeople;
